<template>
  <transition name="el-zoom-in-top">
    <div class="el-color-dropdown" v-show="value">
      <div class="el-color-dropdown__main-wrapper">
        <hue-slider
          ref="hue"
          :color="color"
          vertical
          style="float: right;"
        ></hue-slider>
        <sv-panel ref="sl" :color="color"></sv-panel>
      </div>
      <alpha-slider v-if="showAlpha" ref="alpha" :color="color"></alpha-slider>
      <predefine
        v-if="predefine"
        :color="color"
        :colors="predefine"
      ></predefine>
      <div class="el-color-dropdown__btns">
        <span class="el-color-dropdown__value">
          <sj-input
            border
            v-model="customInput"
            @keyup.native.enter="handleConfirm"
            @blur="handleConfirm"
            :validate-event="false"
            size="small"
          >
          </sj-input>
        </span>
        <!-- <sj-button
          size="mini"
          type="text"
          class="el-color-dropdown__btn"
          v-if="showClear"
          @click="$emit('clear')"
        >
          {{ t("el.colorpicker.clear") }}
        </sj-button> -->
        <sj-button plain size="mini" style="width:60px;" @click="confirmValue">
          <!--{{ t("el.colorpicker.confirm") }}-->
          确认
        </sj-button>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from "../../../../utils/popup/index.js";
import AlphaSlider from "./alpha-slider";
import HueSlider from "./hue-slider";
import Predefine from "./predefine";
import SvPanel from "./sv-panel";

export default {
  name: "el-color-picker-dropdown",

  mixins: [Popup],

  components: {
    SvPanel,
    HueSlider,
    AlphaSlider,
    Predefine
  },

  props: {
    color: {
      required: true
    },
    showAlpha: Boolean,
    predefine: Array,
    showClear: {
      type: Boolean
    },
    value: Boolean
  },

  data() {
    return {
      customInput: ""
    };
  },

  computed: {
    currentColor() {
      const parent = this.$parent;
      return !parent.value && !parent.showPanelColor ? "" : parent.color.value;
    }
  },

  methods: {
    confirmValue() {
      this.$emit("pick");
    },

    handleConfirm() {
      this.color.fromString(this.customInput);
    }
  },

  mounted() {
    this.$parent.popperElm = this.popperElm = this.$el;
    this.referenceElm = this.$parent.$el;
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val === true) {
          this.$nextTick(() => {
            const { sl, hue, alpha } = this.$refs;
            sl && sl.update();
            hue && hue.update();
            alpha && alpha.update();
          });
        }
      }
    },
    // showPicker(val) {
    //   if (val === true) {
    //     this.$nextTick(() => {
    //       const { sl, hue, alpha } = this.$refs;
    //       sl && sl.update();
    //       hue && hue.update();
    //       alpha && alpha.update();
    //     });
    //   }
    // },
    currentColor: {
      immediate: true,
      handler(val) {
        this.customInput = val;
      }
    }
  }
};
</script>
